"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const oidc_client_ts_1 = require("oidc-client-ts");
const authConfig_1 = require("../config/authConfig");
const AuthProvider_1 = require("../components/AuthProvider");
const usersLicence_1 = __importDefault(require("../api/usersLicence"));
const userManager = new oidc_client_ts_1.UserManager(authConfig_1.authConfig);
const Dashboard = () => {
    var _a;
    const { setUser, user } = (0, AuthProvider_1.useAuth)();
    const [licences, setLicences] = (0, react_1.useState)(null);
    const [groupNames, setGroupNames] = (0, react_1.useState)([]);
    const navigate = (0, react_router_dom_1.useNavigate)();
    (0, react_1.useEffect)(() => {
        userManager.signinRedirectCallback()
            .then((user) => {
            setUser(user);
            navigate("/");
        }).catch((err) => {
            console.log(err);
            navigate("/");
        });
    }, [navigate]);
    (0, react_1.useEffect)(() => {
        if (user) {
            usersLicence_1.default.getAllLicences(user.access_token)
                .then((res) => {
                if (res.status == 200) {
                    res.json()
                        .then(response => {
                        setLicences(response);
                    });
                }
                else {
                    setLicences(null);
                    console.log(res.status + " " + res.statusText);
                }
            });
        }
    }, [user]);
    function getValidLicences(licences) {
        return licences === null || licences === void 0 ? void 0 : licences.map((licence) => {
            if (licence.expirationTime && +licence.expirationTime > new Date().getTime()) {
                return licence;
            }
        });
    }
    function getLicencesByGroup(licences) {
        const licenceGroup = new Map();
        licences === null || licences === void 0 ? void 0 : licences.forEach((licence) => {
            var _a, _b;
            const groupName = ((_a = licence.iamGroups[0]) === null || _a === void 0 ? void 0 : _a.groupName) || "Unknown Group";
            if (licenceGroup.has(groupName)) {
                (_b = licenceGroup.get(groupName)) === null || _b === void 0 ? void 0 : _b.push(licence);
            }
            else {
                licenceGroup.set(groupName, [licence]);
            }
        });
        return licenceGroup;
    }
    function renderLicencesByGroup(licences) {
        const licenceGroup = getLicencesByGroup(licences);
        return Array.from(licenceGroup.entries()).map(([groupName, groupLicences]) => (react_1.default.createElement(react_1.default.Fragment, { key: groupName }, react_1.default.createElement("tr", null,
            react_1.default.createElement("td", null, react_1.default.createElement(react_router_dom_1.Link, { to: `/users?groupName=${groupName}` }, groupName.toUpperCase())),
            react_1.default.createElement("td", { align: "center" }, groupLicences.length)))));
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("h1", null, "Just Blink Admin Dashboard"),
        user && react_1.default.createElement("div", null,
            react_1.default.createElement("p", null,
                "Sumaryczna liczba licencji: ",
                licences ? (_a = getValidLicences(licences)) === null || _a === void 0 ? void 0 : _a.length : 0),
            react_1.default.createElement("table", { border: 1 },
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("th", null, "Nazwa"),
                        react_1.default.createElement("th", null, "#Licencji"))),
                react_1.default.createElement("tbody", null, renderLicencesByGroup(licences))))));
};
exports.default = Dashboard;
